<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row">
        <div class="col">
          <app-nav-profile />
        </div>
      </div>
      <div class="row">
        <div class="content-card mb-4">
          <div class="content-card mb-4">
            <div class="content-card-title">
              บัญชีธนาคาร
            </div>
            <div class="content-card-body">
              <div class="row p-2" v-for="item in myBankInfo" :key="item.accountID" :value="item">
                {{  }}
                <div class="border rounded ">
                  <div class="row mb-2  justify-content-center">
                    <div class="col-5 col-sm-4 col-md-2  col-lg-2 pt-2 text-end">
                      <img src="@/assets/icon/bank.png" height=""  id="bank2" class="img-fluid icon-bank detail-bank rounded"
                        >
                    </div>
                    <div
                      class="col col-sm-4 col-md-4 col-lg-3 p-5 d-flex flex-column justify-content-center align-items-start ">
                      <h5 class="mb-0">ธ.{{ item.bankName }}</h5>
                      <h4 class="mb-1" id="acc2" style="margin: 0px 0px 0.25rem;">{{ item.bankNo }}</h4>
                      <span class="badge bg-label-success mb-1">ชื่อบัญชี</span>
                      <h5 > {{ item.bankOwner }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menu_profile from '@/components/sakha/menu_profile'
import { mapState, mapActions } from 'vuex'
export default {
  async created () {
    await this.setLoading(true)
    await this.getMyAccountBanks()
    await this.setLoading(false)
  },
  computed: {
    ...mapState({
      myBankInfo: state => state.bankModule.myBankInfo
    })
  },
  components: {
    'app-nav-profile': menu_profile
  },
  methods: {
    ...mapActions(['getMyAccountBanks', 'setLoading'])
  }
}
</script>

<style>
</style>
